// this is an autogenerated file from App/Account/Topbar/Inbox/Content/mutation-mark-notification-read.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Topbar_Inbox_Content($id: uuid!) {
  update_notifications_users_by_pk(
    pk_columns: { id: $id }
    _set: { status: READ }
  ) {
    id
  }
}

`